import { CircularProgress, Stack, Typography } from '@mui/material'
import { useLazyGetSubscribedSocialOrdersPageQuery } from '../../../../api/socialOrders'
import { SocialOrdersList } from '../../../../components/SocialOrders/SocialOrdersList'
import { useSocialOrdersQueryArgs } from '../../../../hooks/useSocialOrdersQueryArgs'
import { useSocialOrdersWindowedPage } from '../../../../hooks/useSocialOrdersWindowedPage'

export const SocialOrdersSubscriptions = () => {
  const { queryArgs, resetKey } = useSocialOrdersQueryArgs()
  const [loadSocialOrdersPage] = useLazyGetSubscribedSocialOrdersPageQuery()
  const { items, hasMore, isInitialLoading, isFetchingMore, isError, loadMore } =
    useSocialOrdersWindowedPage(resetKey, loadSocialOrdersPage, queryArgs)

  if (isInitialLoading && items.length === 0) {
    return (
      <Stack alignItems="center" justifyContent="center" minHeight="100%">
        <CircularProgress />
      </Stack>
    )
  }

  if (isError) {
    return (
      <Typography color="error" textAlign="center" px={2}>
        Не удалось загрузить подписки на социальные заказы
      </Typography>
    )
  }

  return (
    <SocialOrdersList
      socialOrders={items}
      hasMore={hasMore}
      isLoadingMore={isFetchingMore}
      onLoadMore={loadMore}
      emptyMessage="Здесь будут соцзаказы, на которые вы подписаны"
    />
  )
}
